// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"_3AudU"};